<template>
	<div class="order-details">
		<stepHeader
			msg="Kundinformation"
			:currentStep="3"
			:maxStep="4"
			:useSubtitle="! isActive"
			:useBackgroundColor="useBackgroundColor"
		/>
		<template v-if="isActive && activeStep > 2">
			<form
				v-if="isStoreReservation && canPayInStore"
				class="horizontal-radio-btns"
			>
				<label
					:class="['radio-option', { checked: paymentType === PAY_IN_STORE}]"
					for="paymentType"
				>
					<input type="radio" v-model="paymentType" :value="PAY_IN_STORE" id="paymentType">
					<span class="custom-radio" />

					Betala i butik
				</label>

				<label
					:class="['radio-option', { checked: paymentType === BRIQPAY}]"
					for="prePay"
				>
					<input type="radio" v-model="paymentType" :value="BRIQPAY" id="prePay">
					<span class="custom-radio" />

					Betala nu
				</label>
			</form>
			<customerInfo
				ref="customerInfo"
				:activeStep="activeStep"
				:isActive="isActive"
				:customerInfoData.sync="customerInfoData"
				:confirmedEmail.sync="confirmedEmail"
				:isStoreReservation="isStoreReservation"
				:isCorporateCustomer="isCorporateCustomer"
				:selectedPaymentMethodId="paymentType"
				:selectedShippingMethodId="selectedShippingMethodId"
				:boughtInsurance="boughtInsurance"
				:formFields.sync="formFields"
				:pendingAmount="pendingAmount"
				:disableBoxAddress="disableBoxAddress"
				@updateInvalidArray="invalidArray = $event"
			/>
			<text-button
				class="continue-btn"
				text="Fortsätt"
				:disabled="continueDisabled"
				@click="finished"
			/>
		</template>
		<div
			v-else-if="! isActive && ! useBackgroundColor" @click="updateStep"
			class="list-group col-xs-12"
		>
			<div class="step-info">
				<span class="glyphicon glyphicon-ok ok-mark" />
				Dina uppgifter {{ paymentTypeText }}
				<span class="pull-right" style="font-weight: bold;">Ändra</span>
			</div>
			<template v-if="this.isCorporateCustomer && this.paymentType !== PAY_IN_STORE && !! pendingAmount">
				<template
					v-for="(group, key) in formFieldGroups"
				>
					<span v-if="group.ariaLabel" class="sub-title semibold">
						{{ group.ariaLabel }}
					</span>
					<ul class="sub-title">
						<template v-for="(field, key) in formFieldGroups[key]">
							<li v-if="key !== 'ariaLabel'">
								{{ field }}
							</li>
						</template>
					</ul>
				</template>
			</template>
			<ul v-else class="sub-title">
				<li v-for="(field, key) in formFieldGroups" :key="'field-' + key">
					{{ field }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import stepHeader from './step-header';
import customerInfo from './customer-info';
import { mapGetters } from 'vuex';
import localSessionStorage from 'localSessionStorage';
import { getCartSumExclVat } from 'utils/cart';
import { selectCheckoutOption } from 'gtm';

const BRIQPAY = 1;
const PAY_IN_STORE = 2;

export default {
	components: {
		stepHeader,
		customerInfo,
	},
	props: {
		isActive: {
			type: Boolean,
			required: false,
		},
		selectedShippingMethodId: {
			type: Number,
			required:false,
			default: 0,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		isStoreReservation: {
			type: Boolean,
			required: false,
			default: false,
		},
		cart: {
			type: Object,
			required: true,
		},
		vouchers: {
			type: Array,
			defult: null,
		},
		activeStep: {
			type: Number,
		},
		testConstraint: {
			type: Function,
		},
		pendingAmount: {
			type: Number,
			required: true,
		},
		highestPackageSizeId: {
			type: Number,
			required: true,
		},
	},
	data () {
		return {
			ref: '',
			confirmedEmail: '',
			// pendingAmount: 0,
			invalidArray: [],
			orderError: null,
			selectedPerk: null,
			availablePerk: null,
			missingStep: null,
			customerInfoData: {
				ssn: '',
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				mobile: '',
				zip_code: '',
				city: '',
				street_address: '',
				delivery_corporate_name: '',
				delivery_email: '',
				delivery_phone: '',
				delivery_zip_code: '',
				delivery_city: '',
				delivery_street_address: '',
				delivery_attention: '',
				corporate_name: '',
				corporate_number: '',
			},
			// 1 = BRIQPAY 2 = PAY_IN_STORE
			paymentType: 1,
			BRIQPAY,
			PAY_IN_STORE,
			firstTimeDisplay: true,
			formFields: [],
		};
	},
	mounted () {
		let checkoutData = localSessionStorage.get('checkoutData');
		if (checkoutData) {
			checkoutData = JSON.parse(checkoutData);
		}
		if (checkoutData && checkoutData?.returningFromBriqpay) {
			this.customerInfoData = checkoutData.cutomerInfoData;
			this.paymentType = 1;
			this.firstTimeDisplay = false;
			this.$emit('update:customerInfoData', this.customerInfoData);
		}
	},
	methods: {
		updateStep () {
			bus.$emit('stepUpdated', 3, null);
		},
		login () {
			bus.$emit('header.show');
			bus.$emit('open:login');
		},
		register () {
			bus.$emit('header.show');
			bus.$emit('open:register');
		},
		finished () {
			this.$refs.customerInfo.setErrorStatus('invalid');
			this.$nextTick(() => {
				if (! this.invalidArray.length) {
					this.firstTimeDisplay = false;
					this.$emit('update:customerInfoData', this.customerInfoData);
					this.$emit('stepSelection', { 3: this.paymentType === BRIQPAY ? 'Betala nu' : 'Betala i butik' });
					bus.$emit('stepUpdated', 4);
				}
			});
		},
	},
	computed: {
		canPayInStore () {
			return this.testConstraint('paymentMethod', 2);
		},
		disableBoxAddress () {
			return (this.highestPackageSizeId > 1 || getCartSumExclVat(this.cart) > 1200) && ! this.isStoreReservation;
		},
		continueDisabled () {
			let error = this.invalidArray.length > 0;
			if (this.isCorporateCustomer && this.paymentType === BRIQPAY) {
				error = ! this.customerInfoData.corporate_name.length || ! this.customerInfoData.corporate_number.length;
			}
			return error;
		},
		useBackgroundColor () {
			if ((! this.firstTimeDisplay || ! this.isActive) && this.activeStep < 3) {
				return true;
			} else {
				return false;
			}
		},
		paymentTypeText () {
			return this.paymentType === PAY_IN_STORE ? ' - Betala i butik' : this.isStoreReservation ? ' - Betala nu' : '';
		},
		formFieldGroups () {
			let groups = {};

			if (this.isCorporateCustomer) {
				if (this.paymentType === PAY_IN_STORE || ! this.pendingAmount) {
					groups = {
						name: this.customerInfoData.corporate_name,
						...(this.boughtInsurance && { address: this.customerInfoData.street_address + ', ' + this.customerInfoData.zip_code + ', ' + this.customerInfoData.city}),
						contact: this.customerInfoData.email + ', ' + this.customerInfoData.phone,
					};
				} else {
					groups = {
						base_info: {
							corporate_info: this.customerInfoData.corporate_name + ' - ' + this.customerInfoData.corporate_number,
							contact: this.customerInfoData.email + ', ' + this.customerInfoData.mobile,
						},
						invoice: {
							ariaLabel: 'Faktureringsinformation',
							invoice_address: this.customerInfoData.street_address + ', ' + this.customerInfoData.zip_code + ', ' + this.customerInfoData.city,
						},
						...( ! this.isStoreReservation && {
							delivery: {
								ariaLabel: 'Leveransinformation',
								address: this.customerInfoData.delivery_street_address + ', ' + this.customerInfoData.delivery_zip_code + ', ' + this.customerInfoData.delivery_city,
								contact: this.customerInfoData.delivery_email + ', ' + this.customerInfoData.delivery_phone,
								attention: 'Att/Godsmärkning: ' + this.customerInfoData.delivery_attention,
							}
						}),
					};

				}

			} else {
				const phone = this.paymentType === PAY_IN_STORE ? this.customerInfoData.phone : this.customerInfoData.mobile;
				groups = {
					...((this.boughtInsurance || (this.paymentType === BRIQPAY && this.pendingAmount) || ! this.isStoreReservation) && {
						name: this.customerInfoData.first_name  + ' ' + this.customerInfoData.last_name,
						address: this.customerInfoData.street_address + ', ' + this.customerInfoData.zip_code + ', ' + this.customerInfoData.city
					}),
					contact: this.customerInfoData.email + ', ' + phone,
				};
			}

			return groups;
		},
		boughtInsurance () {
			return this.cart.rows.some(row => row.extraData && row.extraData.insured);
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			rankLevel: 'user/rankLevel',
		}),
	},
	watch: {
		missingStep (to) {
			if (to) {
				this.$emit('missingStep',to);
			}
		},
		isStoreReservation (to) {
			if (! to) {
				this.paymentType = BRIQPAY;
			}
		},
		canPayInStore (to) {
			if (! to) {
				this.paymentType = BRIQPAY;
			}
		},
		paymentType (to) {
			selectCheckoutOption(3, to === BRIQPAY ? 'Betala nu' : 'Betala i butik');
			this.$emit('update:pickupAndPayInStore', to === PAY_IN_STORE);
		},
	},
};
</script>
